import React from 'react';
import { Shield, Edit, Trash2, ChevronRight, Users, Lock } from 'lucide-react';

const RoleList = ({ roles, selectedRole, onSelectRole, onEditRole, onDeleteRole, loading }) => {
    if (loading) {
        return (
            <div className="bg-[#1a1a1a] border border-white/10 rounded-xl p-6 text-center text-gray-400">
                <div className="animate-spin w-6 h-6 border-2 border-orange-500 border-t-transparent rounded-full mx-auto mb-2"></div>
                Yükleniyor...
            </div>
        );
    }

    return (
        <div className="bg-[#1a1a1a] border border-white/10 rounded-xl overflow-hidden shadow-lg h-full flex flex-col">
            <div className="p-4 border-b border-white/10 bg-[#252525] flex justify-between items-center">
                <h3 className="text-lg font-semibold text-white flex items-center gap-2">
                    <Shield className="w-5 h-5 text-orange-500" />
                    Roller
                </h3>
                <span className="text-xs px-2 py-1 rounded-full bg-white/5 text-gray-400">
                    {roles.length} Rol
                </span>
            </div>

            <div className="flex-1 overflow-y-auto p-2 space-y-2 custom-scrollbar">
                {roles.length === 0 ? (
                    <div className="text-center py-8 text-gray-500">
                        <Shield className="w-10 h-10 mx-auto mb-2 opacity-50" />
                        <p>Hennüz rol bulunmuyor.</p>
                    </div>
                ) : (
                    roles.map((role) => {
                        const isSelected = selectedRole?.id === role.id;
                        const isRoot = role.name === 'root';

                        return (
                            <div
                                key={role.id}
                                onClick={() => onSelectRole(role)}
                                className={`group relative p-3 rounded-lg border transition-all cursor-pointer ${isSelected
                                        ? 'bg-orange-500/10 border-orange-500/50 shadow-md shadow-orange-500/10'
                                        : 'bg-[#1e1e1e] border-white/5 hover:border-white/10 hover:bg-[#252525]'
                                    }`}
                            >
                                <div className="flex justify-between items-start mb-2">
                                    <div>
                                        <h4 className={`font-medium text-sm flex items-center gap-2 ${isSelected ? 'text-orange-400' : 'text-gray-200'}`}>
                                            {role.name}
                                            {isRoot && <Lock className="w-3 h-3 text-red-500" />}
                                        </h4>
                                    </div>

                                    <div className="flex items-center gap-1 opacity-100 sm:opacity-0 group-hover:opacity-100 transition-opacity">
                                        <button
                                            onClick={(e) => { e.stopPropagation(); onEditRole(role); }}
                                            className="p-1.5 text-blue-400 hover:bg-blue-500/10 rounded-lg transition-colors"
                                            title="Düzenle"
                                        >
                                            <Edit className="w-3.5 h-3.5" />
                                        </button>
                                        {!isRoot && (
                                            <button
                                                onClick={(e) => { e.stopPropagation(); onDeleteRole(role); }}
                                                className="p-1.5 text-red-400 hover:bg-red-500/10 rounded-lg transition-colors"
                                                title="Sil"
                                            >
                                                <Trash2 className="w-3.5 h-3.5" />
                                            </button>
                                        )}
                                    </div>
                                </div>

                                <p className="text-xs text-gray-500 line-clamp-2 mb-3 h-8">
                                    {role.description || 'Açıklama yok'}
                                </p>

                                <div className="flex items-center justify-between text-xs pt-2 border-t border-white/5">
                                    <div className="flex items-center gap-1 text-gray-400">
                                        <Users className="w-3 h-3" />
                                        {/* We assume role object might have user count or we don't know it yet */}
                                        {/* userCount is not typically in getRoles response based on old code, but let's leave it simple */}
                                        <span>Detaylar</span>
                                    </div>
                                    {isSelected && <ChevronRight className="w-4 h-4 text-orange-500" />}
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
};

export default RoleList;
